import { AuxiliumComponent } from "../auxilium-component";

export default class ProgressBar extends AuxiliumComponent {
  static observable = ["value", "max", "label", "secondary-label", "helper-text", "variation"];
  static observableBooleans = ["indeterminate"];

  constructor() {
    super();

    this.min = this.getAttribute("min") ?? "0";
    this.max = this.getAttribute("max") ?? "100";
    this.low = this.getAttribute("low") ?? this.min;
    this.lowWarning = this.getAttribute("low-warning") ?? this.min;
    this.high = this.getAttribute("high") ?? this.max;
    this.highWarning = this.getAttribute("high-warning") ?? this.max;
    this.value = this.getAttribute("value") ?? (this.indeterminate ? this.max : "0");
  }

  parsedCallback() {
    if (this.label) {
      this.appendChild(document.createElementWithContents("label", this.label, {
        className: "input-field__label"
      }));
    }

    const progress = document.createElementWithContents("progress", null, {
      id: this.identifier,
      max: this.max,
      value: this.value
    });

    this.appendChild(progress);

    if (this.indeterminate) {
      this.appendChild(document.createElementWithContents("div",
        `
        <div class="progress-fill"></div>
      `
        , { className: "progress-bar" }));
    }

    this.#updateState();
  }

  #updateState() {
    this.toggleClass("progress--low", (parseInt(this.value) || 0) < (parseInt(this.low) || 0));
    this.toggleClass("progress--high", (parseInt(this.value) || 0) > (parseInt(this.high) || 0));
    this.toggleClass("progress--low-warning", (parseInt(this.value) || 0) < (parseInt(this.lowWarning) || 0) && !this.classList.contains("progress--low"));
    this.toggleClass("progress--high-warning", (parseInt(this.value) || 0) > (parseInt(this.highWarning) || 0) && !this.classList.contains("progress--high"));
  }

  attributeChanged(name, _, newValue) {
    switch (name) {
      case "max":
        {
          const bar = this.querySelector("progress");

          if (bar) { bar.max = newValue; }
        }
        break;
      case "value":
        {
          const bar = this.querySelector("progress");

          if (bar && !this.indeterminate) { bar.value = newValue; }
          this.#updateState();
        }
        break;
      case "label":
        {
          const element = this.querySelector(".input-field__label");

          if (element) {
            element.textContent = newValue;
          } else {
            this.prepend(document.createElementWithContents("label", newValue, {
              className: "input-field__label"
            }));
          }
        }
        break;
    }
  };
}
